<script>
import { useCurrentUser } from './user/useCurrentUser'
import { watch } from '@vue/composition-api'
import { useRouter, STORE_ROUTE_BEFORE_REDIRECT } from '@/util/router'
import Landing from './Landing.vue'

export default {
  setup () {
    const { currentUser, loading } = useCurrentUser()
    const router = useRouter()

    const routeBeforeRedirect = localStorage.getItem(STORE_ROUTE_BEFORE_REDIRECT)
    localStorage.removeItem(STORE_ROUTE_BEFORE_REDIRECT)

    function shouldRedirectToSavedRoute () {
      if (routeBeforeRedirect && routeBeforeRedirect !== '/') {
        router.push(routeBeforeRedirect)
        return true
      }
    }

    watch(currentUser, value => {
      if (value) {
        if (!shouldRedirectToSavedRoute()) {
          router.replace({
            name: 'dashboard',
          })
        }
      }
    })

    return {
      currentUser,
      loading,
    }
  },

  render (h) {
    if (this.loading || this.currentUser) {
      return null
    } else {
      return <Landing/>
    }
  },
}
</script>
